import httpClient from "../httpClient";

function getAutomations(params = {}) {
  return httpClient.get("/automation-monitoring/automations", { params });
}

function getAutomationRuns(automationId, params = {}) {
  return httpClient.get(`/automation-monitoring/automations/${encodeURIComponent(automationId)}/runs`, { params });
}

function getRun(automationId, runId) {
  return httpClient.get(`/automation-monitoring/runs/${encodeURIComponent(runId)}`, {
    params: { automationId },
  });
}

function getAutomationDetail(automationId, params = {}) {
  return httpClient.get(`/automation-monitoring/automations/${encodeURIComponent(automationId)}/detail`, { params });
}

function getIncidents(params = {}) {
  return httpClient.get("/automation-monitoring/incidents", { params });
}

function getComparison(params = {}) {
  return httpClient.get("/automation-monitoring/comparison", { params });
}

function searchSubject(payload) {
  return httpClient.post("/automation-monitoring/subjects/search", payload);
}

export default {
  getAutomations,
  getAutomationRuns,
  getRun,
  getAutomationDetail,
  getIncidents,
  getComparison,
  searchSubject,
};
